var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHousePrint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    rx: 5,
    fill: "#1CB978"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 14.9395L31 23.9395V30.25C31 30.8467 30.7629 31.419 30.341 31.841C29.919 32.2629 29.3467 32.5 28.75 32.5H15.25C14.6533 32.5 14.081 32.2629 13.659 31.841C13.2371 31.419 13 30.8467 13 30.25V23.9395L22 14.9395ZM29.5 13.75V19L26.5 16V13.75C26.5 13.5511 26.579 13.3603 26.7197 13.2197C26.8603 13.079 27.0511 13 27.25 13H28.75C28.9489 13 29.1397 13.079 29.2803 13.2197C29.421 13.3603 29.5 13.5511 29.5 13.75Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9404 12.2502C21.2217 11.969 21.6032 11.811 22.0009 11.811C22.3987 11.811 22.7802 11.969 23.0614 12.2502L33.0319 22.2192C33.1728 22.36 33.2519 22.5511 33.2519 22.7502C33.2519 22.9494 33.1728 23.1404 33.0319 23.2812C32.8911 23.422 32.7001 23.5012 32.5009 23.5012C32.3018 23.5012 32.1108 23.422 31.9699 23.2812L22.0009 13.3107L12.0319 23.2812C11.8911 23.422 11.7001 23.5012 11.5009 23.5012C11.3018 23.5012 11.1108 23.422 10.9699 23.2812C10.8291 23.1404 10.75 22.9494 10.75 22.7502C10.75 22.5511 10.8291 22.36 10.9699 22.2192L20.9404 12.2502Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousePrint);
export default __webpack_public_path__ + "static/media/house-print.a38faca2e75a30b9b25d31f147074f5d.svg";
export { ForwardRef as ReactComponent };